module.exports = __webpack_public_path__ + "static/media/meralco.c1d2a025.png";